import defaultState from '@/store/modules/auctions/defaultState';

const actions = {
  getMyAcvSoldAuctions(
    {
      dispatch,
    },
    { page = 1 },
  ) {
    return dispatch('getAuctionList', {
      apiMethod: 'getMyAcvSoldAuctions',
      moduleKey: 'MyAcvSold',
      numberOfLoaders: 10,
      page,
    });
  },
};

export default {
  state: defaultState,
  actions,
};
